module.exports = __webpack_public_path__ + "img/datahub-1.ef28e770.png";